// Aggregation types
export const AGG = {
  SUM: 'sum',
  DISTINCT: 'distinct',
  CONDITIONAL: 'conditional',
  AUTO_MIN: 'auto_min',
  AUTO_MAX: 'auto_max',
};
